import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
import ElementUI from 'element-ui';  
import 'element-ui/lib/theme-chalk/index.css'; 
import * as echarts from 'echarts';
// 引入hightcharts
import Highcharts from "highcharts";
import venn from 'highcharts/modules/venn';
import HighchartsVue from 'highcharts-vue';
//引入iconfont
import './assets/fonts/download/font_4359022_lwkam3rk2ul/iconfont.css'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(ElementUI); 
Vue.prototype.$echarts = echarts;
Vue.use(HighchartsVue);

// 引入hightcharts中的venn模块（否则韦恩图出不来）
venn(Highcharts);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})





// WEBPACK FOOTER //
// ./src/main.js